import React from 'react';
import { Typography, Box } from '@mui/material';

const AdminUsers = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Admin Users Management
            </Typography>
            <Typography variant="body1">
                This is the users management page. Only accessible via /admin/users
            </Typography>
        </Box>
    );
};

export default AdminUsers;
